module.exports = __webpack_public_path__ + "img/ticket_star.9c23eeac.svg";